import Video3 from "../videos/3.mp4";
import VideoAbril2 from "../videos/Abril (2).mp4";
import VideoAbril from "../videos/Abril.mp4";
import VideoAyunVale from "../videos/ayun vale.mp4";
import VideoAzul from "../videos/Azul.mp4";
import VideoElias from "../videos/Elias.mp4";
import VideoIlia from "../videos/Ilia.mp4";
import VideoMonica from "../videos/Monica.mp4";
import VideoNicoleMoraga from "../videos/Nicole Moraga.mp4";
import VideoPancha from "../videos/pancha.mp4";
import VideoRO from "../videos/RO.mp4";
import VideoRulos from "../videos/Rulos.mp4";
import VideoSebastianSanMartin from "../videos/Sebastian San Martín.mp4";
import videoplus from "../videos/Secuencia 02.mp4"
import VideoSecuencia02_1 from "../videos/Secuencia 02_1.mp4";
import VideoSecuencia02_2 from "../videos/Secuencia 02_2.mp4";
import VideoSecuencia02_3 from "../videos/Secuencia 02_3.mp4";
import VideoSecuencia02_4 from "../videos/Secuencia 02_4.mp4";
import VideoSecuencia from "../videos/Secuencia.mp4";
import VideoSol from "../videos/Sol.mp4";

const json = [
  Video3,
  VideoAbril2,
  VideoAbril,
  VideoAyunVale,
  VideoAzul,
  VideoElias,
  VideoIlia,
  VideoMonica,
  VideoNicoleMoraga,
  VideoPancha,
  VideoRO,
  VideoRulos,
  VideoSebastianSanMartin,
  VideoSecuencia02_1,
  VideoSecuencia02_2,
  VideoSecuencia02_3,
  VideoSecuencia02_4,
  VideoSecuencia,
  VideoSol,
  videoplus
];

export default json;
